import { Observer } from 'mobx-react';
import * as React from 'react';
import { FC } from 'react';

import { Modal } from 'components/modal';

import { ResultsForm } from '../containers';

import { reloadDistance } from '../actions';

import { resultStore } from '../stores';

type Props = {};

export const ResultsFormModal: FC<Props> = () => (
  <Observer>
    {() => {
      return (
        <Modal open={resultStore.isOpenEditResult}>
          <ResultsForm loadHandler={reloadDistance} />
        </Modal>
      );
    }}
  </Observer>
);
